import { Component, Input } from '@angular/core'
import { Breadcrumb } from '@mmx/shared'
import { filter, isString } from 'lodash'

@Component({
  selector: 'mmx-breadcrumbs',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false,
})
export class BreadcrumbComponent {
  @Input() title = true
  @Input() breadcrumbs?: Breadcrumb[]

  get visibleBreadcrumbs(): Breadcrumb[] {
    return filter(this.breadcrumbs || []).map((breadcrumb) => {
      if (isString(breadcrumb)) {
        return { text: breadcrumb }
      }

      return breadcrumb
    })
  }
}
